<template>
  <component
    :is="component"
    :reference="reference"
    :reference-event-log="referenceEventLog"
    :current-researcher="currentResearcher"
    :bottom-node="bottomNode"
  />
</template>

<script>
import UploadEventLogItem from '@/components/EventLog/UploadEventLogItem';
import DuplicateEventLogItem from '@/components/EventLog/DuplicateEventLogItem';
import ScreeningEventLogItem from '@/components/EventLog/ScreeningEventLogItem';
import FullTextReviewEventLogItem from '@/components/EventLog/FullTextReviewEventLogItem';
import DataExtractionEventLogItem from '@/components/EventLog/DataExtractionEventLogItem';
import CommentEventLogItem from '@/components/EventLog/CommentEventLogItem';
import TagEventLogItem from '@/components/EventLog/TagEventLogItem';
import FullTextPdfEventLogItem from '@/components/EventLog/FullTextPdfEventLogItem';
import FullTextPdfFetchEventLogItem from '@/components/EventLog/FullTextPdfFetchEventLogItem';
import { ReferenceEventLog, Reference, Researcher } from '@/models';
import { ReferenceEvent } from '@/enums';

const EVENT_TO_COMP = {
  [ReferenceEvent.UPLOAD]: UploadEventLogItem,
  [ReferenceEvent.DUPLICATE_STATE_UPDATE]: DuplicateEventLogItem,
  [ReferenceEvent.SCREENING_VOTE_CREATE]: ScreeningEventLogItem,
  [ReferenceEvent.SCREENING_VOTE_UPDATE]: ScreeningEventLogItem,
  [ReferenceEvent.SCREENING_VOTE_CONFLICT]: ScreeningEventLogItem,
  [ReferenceEvent.SCREENING_VOTE_REVOKE]: ScreeningEventLogItem,
  [ReferenceEvent.SCREENING_OUTCOME_CREATE]: ScreeningEventLogItem,
  [ReferenceEvent.SCREENING_OUTCOME_UPDATE]: ScreeningEventLogItem,
  [ReferenceEvent.SCREENING_OUTCOME_REVOKE]: ScreeningEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_CREATE]: FullTextReviewEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_UPDATE]: FullTextReviewEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_CONFLICT]: FullTextReviewEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_REVOKE]: FullTextReviewEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_OUTCOME_CREATE]: FullTextReviewEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_OUTCOME_UPDATE]: FullTextReviewEventLogItem,
  [ReferenceEvent.FULL_TEXT_REVIEW_OUTCOME_REVOKE]: FullTextReviewEventLogItem,
  [ReferenceEvent.DATA_EXTRACTION_REPORT_PROPOSAL]: DataExtractionEventLogItem,
  [ReferenceEvent.DATA_EXTRACTION_REPORT_ACCEPTED]: DataExtractionEventLogItem,
  [ReferenceEvent.COMMENT_CREATE]: CommentEventLogItem,
  [ReferenceEvent.COMMENT_EDIT]: CommentEventLogItem,
  [ReferenceEvent.COMMENT_DELETE]: CommentEventLogItem,
  [ReferenceEvent.TAG_ADD]: TagEventLogItem,
  [ReferenceEvent.TAG_REMOVE]: TagEventLogItem,
  [ReferenceEvent.FULL_TEXT_PDF_UPLOAD]: FullTextPdfEventLogItem,
  [ReferenceEvent.FULL_TEXT_PDF_UPDATE]: FullTextPdfEventLogItem,
  [ReferenceEvent.FULL_TEXT_PDF_DELETE]: FullTextPdfEventLogItem,
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_STARTED]: FullTextPdfFetchEventLogItem,
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_NOT_FOUND]: FullTextPdfFetchEventLogItem,
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_ERROR]: FullTextPdfFetchEventLogItem,
};

export default {
  name: 'EventLogItem',
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    referenceEventLog: {
      type: ReferenceEventLog,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      default: null,
    },
    bottomNode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component() {
      return EVENT_TO_COMP[this.referenceEventLog.event];
    },
  },
};
</script>
